import ApplicationController from "~/controllers/application_controller"

export default class extends ApplicationController {
  static values = { itemsCount: Number }

  itemsCountValueChanged() {
    document.body.classList.toggle("items-in-cart", this.itemsCountValue > 0)
  }
}
